// extracted by mini-css-extract-plugin
export default {"startMenuAppsContList":"start-menu-cont-apps-list-pined_startMenuAppsContList__gJGHE"};